import consentManagerActionsTypes from './consentManagerActionsTypes';
export function setConsentManagerMode(displayMode) {
  return {
    type: consentManagerActionsTypes.SET_CONSENT_MODE,
    payload: {
      displayMode: displayMode
    }
  };
}
export function openConsentManagerDialog() {
  return {
    type: consentManagerActionsTypes.OPEN_CONSENT_DIALOG
  };
}
export function closeConsentManagerDialog() {
  return {
    type: consentManagerActionsTypes.CLOSE_CONSENT_DIALOG
  };
}